import locationallComponent from './location.all.component';

let locationallModule = angular.module('locationall', [
])

.component('locationall', locationallComponent)

.name;

export default locationallModule;


// WEBPACK FOOTER //
// ./client/app/components/location/all/index.js